export default __webpack_public_path__ + "static/media/drake.b1a965b3.jpg";